import { Button } from "@/components/elements/Button";
import { Form } from "@/components/elements/Form";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { registerSchema } from "@/features/auth/schema/registerSchema";
import { registerApi } from "@/features/auth/services/registerApi";
import { TRegisterForm } from "@/features/auth/types/registerForm";
import { TRegisterQueryParam } from "@/features/auth/types/registerQueryParam";
import { AppRoutes } from "@/routes/config";
import { text } from "@/theme/colors";
import { showError } from "@/utils/error";
import { getQueryFromURL } from "@/utils/url";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, Stack, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const initValue: TRegisterForm = {
  email: "",
  confirmPassword: "",
  password: "",
};

export const RegisterForm = () => {
  const query = getQueryFromURL<TRegisterQueryParam>();
  const navigate = useNavigate();
  const methods = useForm<TRegisterForm>({
    defaultValues: {
      ...initValue,
      email: query?.email || "",
    },
    resolver: yupResolver(registerSchema),
    mode: "onChange",
  });
  const { control } = methods;

  const onSubmit = async (data: TRegisterForm) => {
    if (!query) return null;
    try {
      await registerApi({
        email: data.email,
        password: data.password,
        resetToken: query.resetToken,
      });
      navigate(AppRoutes.registerComplete);
    } catch (error) {
      showError(error);
    }
  };

  return (
    <Form methods={methods} onSubmit={onSubmit} enableBlocker={false} schema={registerSchema}>
      <Stack width={400} gap={4} alignItems="center">
        <Typography variant="head20Bold">新規管理者アカウント登録</Typography>
        <Grid container>
          <Grid item xs={12} my={1.5}>
            <FormField control={control} name="email">
              <Input size="lg" readonly />
            </FormField>
          </Grid>
          <Grid item xs={12} my={1.5}>
            <FormField control={control} name="password">
              <Input size="lg" type="password" />
            </FormField>
          </Grid>
          <Grid item xs={12} my={1.5}>
            <FormField control={control} name="confirmPassword">
              <Input size="lg" type="password" />
            </FormField>
          </Grid>
          <Typography variant="body14" color={text.secondary}>
            ※パスワードはアルファベット大文字・小文字・数字・記号を含む12文字以上で入力してください。
          </Typography>
        </Grid>
        <Button fullWidth type="submit" size="sm">
          アカウントを登録する
        </Button>
      </Stack>
    </Form>
  );
};
